import React, { useState, useEffect } from 'react'
import { Box, Grid, Tabs, Tab, CircularProgress, Paper, Typography, Stepper, Step, StepLabel, StepConnector, Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import ReleaseInfo from '../../../components/Releases/CreateReleases/ReleaseInfo';
import SongInfo from '../../../components/Releases/CreateReleases/SongInfo';
import Platform from '../../../components/Releases/CreateReleases/Platform';
import Submission from '../../../components/Releases/CreateReleases/Submission';
import * as actions from "./actions"
import CustomAddModal from '../../../components/Common/CustomAddModal';
import AddArtist from './AddArtist';
import { getHeaders, removeObject, saveObject, toastError, toastSuccess } from '../../../utils';
import * as commonActions from "../../common/actions"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ConfirmModal from '../../../components/Common/CommonModal';
import axios from "axios"
import { API_URL } from '../../../constants';
import SongDetailForm from '../../../components/Releases/CreateReleases/SongDetailForm';
import moment from "moment"
import { useParams } from "react-router-dom"
import noaccess from "../../../assets/img/noaccess.png"
import AlbumIcon from '@mui/icons-material/Album';
import InfoIcon from '@mui/icons-material/Info';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SendIcon from '@mui/icons-material/Send';
import AwayStatusModal from '../../../components/Common/AwayStatusModal';
import SEO from '../../../components/SEO';

// Styled Components
const PageContainer = styled(Box)({
    minHeight: 'calc(100vh - 64px)',
    background: 'linear-gradient(135deg, #e8eef3 0%, #dce4ec 100%)',
    padding: '32px 24px',
    position: 'relative',
});

const PageHeader = styled(Box)({
    marginBottom: '32px',
    '& h1': {
        fontSize: '2rem',
        fontWeight: 700,
        background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        marginBottom: '8px',
        fontFamily: "'DM Sans', sans-serif",
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
});

const StyledPaper = styled(Paper)({
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
    background: '#ffffff',
});

const StyledTabs = styled(Tabs)({
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    borderBottom: '2px solid rgba(26, 115, 232, 0.1)',
    '& .MuiTabs-indicator': {
        background: 'linear-gradient(90deg, #1a73e8 0%, #00bfa5 100%)',
        height: '3px',
        borderRadius: '3px 3px 0 0',
    },
    '& .MuiTabs-flexContainer': {
        justifyContent: 'center',
    },
});

const StyledTab = styled(Tab)(({ theme }) => ({
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '1rem',
    fontWeight: 600,
    textTransform: 'none',
    minHeight: '64px',
    transition: 'all 0.3s ease',
    color: '#5f6368',
    '&.Mui-selected': {
        background: 'linear-gradient(135deg, rgba(26, 115, 232, 0.08) 0%, rgba(0, 191, 165, 0.08) 100%)',
        color: '#1a73e8',
    },
    '&:hover': {
        background: 'rgba(26, 115, 232, 0.05)',
    },
}));

const TabPanelContainer = styled(Box)({
    padding: '32px 24px',
    minHeight: '400px',
});

// Stepper Styled Components
const StepperContainer = styled(Box)({
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    padding: '32px 24px',
    borderBottom: '2px solid rgba(26, 115, 232, 0.1)',
});

const StyledStepper = styled(Stepper)({
    '& .MuiStepLabel-root': {
        cursor: 'pointer',
    },
});

const StyledStepConnector = styled(StepConnector)(({ theme }) => ({
    top: '28px',
    left: 'calc(-50% + 28px)',
    right: 'calc(50% + 28px)',
    '& .MuiStepConnector-line': {
        borderColor: 'rgba(0, 0, 0, 0.12)',
        borderTopWidth: '3px',
        borderRadius: '1px',
    },
    '&.Mui-active .MuiStepConnector-line': {
        borderColor: '#1a73e8',
    },
    '&.Mui-completed .MuiStepConnector-line': {
        borderColor: '#00bfa5',
    },
}));

const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
    '& .MuiStepLabel-label': {
        fontFamily: "'DM Sans', sans-serif",
        fontSize: '1rem',
        fontWeight: 600,
        color: '#5f6368',
        marginTop: '8px',
    },
    '& .MuiStepLabel-label.Mui-active': {
        color: '#1a73e8',
        fontWeight: 700,
    },
    '& .MuiStepLabel-label.Mui-completed': {
        color: '#00bfa5',
        fontWeight: 600,
    },
    '& .MuiStepIcon-root': {
        fontSize: '2.5rem',
        color: 'rgba(0, 0, 0, 0.12)',
    },
    '& .MuiStepIcon-root.Mui-active': {
        color: '#1a73e8',
    },
    '& .MuiStepIcon-root.Mui-completed': {
        color: '#00bfa5',
    },
    '& .MuiStepIcon-text': {
        fill: '#ffffff',
        fontWeight: 700,
        fontFamily: "'DM Sans', sans-serif",
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && (
                <TabPanelContainer>
                    {children}
                </TabPanelContainer>
            )}
        </div>
    );
}

const initialArtist = {
    artist_type: "primary",
    artist_name: "",
    apple_id: "",
    spotify_id: ""
}

const initialReleaseInfo = {
    album_artwork: "",
    release_title: "",
    release_type: "single",
    primary_artist1: "",
    primary_artist2: "",
    primary_artist3: "",
    featuring1: "",
    featuring2: "",
    featuring3: "",
    genre: "",
    sub_genre: "",
    lable_name: "",
    release_date: "",
    ogn_release_date: "",
    p_line: "",
    cour_line: "",
    c_line: "",
    upc_ean: "",
    add_info: ""
}

const initialSongInfo = {
    release_id: "",
    audio_track: "",
    track_version: "Original",
    instrumental: "No",
    title: "",
    version_subtitle: "",
    primary_artist1: "",
    primary_artist2: "",
    primary_artist3: "",
    featuring1: "",
    featuring2: "",
    featuring3: "",
    author1: "",
    author2: "",
    author3: "",
    composer1: "",
    composer2: "",
    composer3: "",
    producer: "",
    p_line: "",
    production_year: moment().format('yyyy'),
    publisher: "",
    isrc_yes_no: "No",
    isrc: "",
    genre: "",
    subgenre: "",
    price_tier: "",
    explicit_version: "No",
    track_title_language: "",
    lyrics_language: "",
    lyrics: "",
    caller_tune: "",
    destribute_music: "No",
    video_isrc: "",
    download_video_link: "",
    saved: false,
    edit: false,
}

export default function CreateReleases(props) {

    const params = useParams()

    const [tabIndex, setTabIndex] = useState(1)
    const [recipeFilePreview, setRecipeFilePreview] = useState('')
    const [primaryArtist, setPrimaryArtist] = useState([])
    const [featuringArtist, setFeaturingArtist] = useState([])
    const [openAddPrimary, setOpenAddPrimary] = useState(false)
    const [openAddFeaturing, setOpenAddFeaturing] = useState(false)
    const [addArtist, setAddArtist] = useState({ ...initialArtist })
    const [selectedPrimaryArtist, setSelectedPrimaryArtist] = useState([])
    const [selectedFeaturingArtist, setSelectedFeaturingArtist] = useState([])
    const [releaseInfo, setReleaseInfo] = useState({ ...initialReleaseInfo })
    const [stepsDone, setStepsDone] = useState({
        first: false,
        second: false,
        third: false,
        fourth: false
    })
    const [disableTab, setDisableTab] = useState({
        first: false,
        second: true,
        third: true,
        fourth: true
    })
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [showUpload, setShowUpload] = useState(false)
    const [songInfo, setSongInfo] = useState({ ...initialSongInfo });
    const [uploadProgress, setUploadProgress] = useState(0)
    const [isProgressDone, setIsProgressDone] = useState(false)
    const [openSongDetail, setOpenSongDetail] = useState(false)

    const [selectedSongPrimaryArtist, setSelectedSongPrimaryArtist] = useState([])
    const [selectedSongfeaturingArtist, setSelectedSongfeaturingArtist] = useState([])
    const [selectedSongAuthor, setSelectedSongAuthor] = useState([{ firstName: "", lastName: "" }])
    const [selectedSongComposer, setSelectedSongComposer] = useState([{ firstName: "", lastName: "" }])

    const [currentEditIndex, setCurrentEditIndex] = useState(0)
    const [savedSongsDetails, setSavedSongsDetails] = useState([{ ...initialSongInfo }])
    const [releaseID, setReleaseID] = useState(null);
    const [platformLogo, setPlatformLogo] = useState([])
    const [showSubmitSong, setShowSubmitSong] = useState(false)
    const [insertDraft, setInsertDraft] = useState(false)
    const [editMode, setEditMode] = useState(false)
    const [releaseDateError, setReleaseDateError] = useState('')

    const [platform, setPlatform] = useState({
        release_id: null,
        crbt: "no",
        video_platforms: "no"
    })
    const [isUserRevoked, setIsUserRevoked] = useState(false)
    const [initialLoader, setInitialLoader] = useState(true)
    const [songInfoMusicLink, setSongInfoMusicLink] = useState(null);
    const [selectedAudioFile, setSelectedAudioFile] = useState(null);
    const [awayData, setAwayData] = useState({
        status: false,
        text: ''
    })

    useEffect(() => {
        props.setLoader(true)
        actions.checkAwayStatus().then(res => {
            const isAway = (res && res.body && res.body.status && res.body.status === "yes" && true) || false
            const awayText = (res && res.body && res.body.text && res.body.text) || ''
            if (isAway) {
                setInitialLoader(false)
                props.setLoader(false)
                setAwayData({
                    status: true,
                    text: awayText
                })
            } else {
                actions.checkUserRevokeStatus().then(res => {
                    props.setLoader(false)
                    setInitialLoader(false)
                    if (res.revoked === 1) {
                        setIsUserRevoked(true)
                    } else {
                        setIsUserRevoked(false)
                        onFetchArtists();
                        onFetchLogos();
                        if (params.id) {
                            props.setLoader(true)
                            setEditMode(true)
                            setReleaseID(Number(params.id))
                        }
                    }
                }).catch(err => {
                    props.setLoader(false)
                    // setInitialLoader(false)
                    toastError(err.message)
                })
            }
        })
        return () => {
            setReleaseID(null)
            removeObject('releaseId')
            removeObject('releaseInfo')
        }
    }, [])

    useEffect(() => {
        if (params.id && insertDraft) {
            actions.getDraft(params.id).then(res => {
                props.setLoader(false)
                const { album_artwork = '', release_title = '', release_type = '', genre = '', sub_genre = '', lable_name = '', release_date = '', ogn_release_date = '', add_info = '',
                    p_line = '', cour_line = '', c_line = '', upc_ean = '', primary_artist1 = '', primary_artist2 = '', primary_artist3 = '', featuring1 = '', featuring2 = '', featuring3 = '',
                    audios = [], crbt = '', video_platforms = '' } = res.body;
                let audioExists = (Array.isArray(audios) && audios.length > 0 ? true : false) || false
                setStepsDone({ ...stepsDone, first: true, second: audioExists, third: (crbt === 'yes' || video_platforms === 'yes') })
                setPlatform({ release_id: Number(params.id), crbt, video_platforms })
                setDisableTab({ first: false, second: false, third: !audioExists, fourth: true })

                // Validate release date
                const minDate = moment().add(6, 'd').startOf('day').valueOf()
                let validatedReleaseDate = null
                if (release_date) {
                    const savedDate = Number(release_date)
                    if (savedDate < minDate) {
                        // Date is invalid, clear it and show error
                        setReleaseDateError('The saved release date is no longer valid. Please select a new date (minimum 6 days from today).')
                        validatedReleaseDate = null
                    } else {
                        // Date is valid
                        validatedReleaseDate = savedDate
                        setReleaseDateError('')
                    }
                } else {
                    setReleaseDateError('')
                }

                setReleaseInfo({
                    ...res.body,
                    album_artwork: album_artwork,
                    release_title: release_title,
                    release_type: release_type,
                    primary_artist1: "",
                    primary_artist2: "",
                    primary_artist3: "",
                    featuring1: "",
                    featuring2: "",
                    featuring3: "",
                    genre: genre,
                    sub_genre: sub_genre,
                    lable_name: lable_name,
                    release_date: validatedReleaseDate,
                    ogn_release_date: ogn_release_date,
                    p_line: p_line,
                    cour_line: cour_line,
                    c_line: c_line,
                    upc_ean: upc_ean,
                    add_info: add_info
                })
                let primary = []
                if (primary_artist1) {
                    primary.push(Number(primary_artist1))
                }
                if (primary_artist2) {
                    primary.push(Number(primary_artist2))
                }
                if (primary_artist3) {
                    primary.push(Number(primary_artist3))
                }

                primary = primary.map(artist => primaryArtist.find(item => item.artist_id === artist))
                setSelectedPrimaryArtist(primary)

                let featuring = []
                if (featuring1) {
                    featuring.push(Number(featuring1))
                }
                if (featuring2) {
                    featuring.push(Number(featuring2))
                }
                if (featuring3) {
                    featuring.push(Number(featuring3))
                }
                featuring = featuring.map(artist => featuringArtist.find(item => item.artist_id === artist))
                setSelectedFeaturingArtist(featuring)

                if (Array.isArray(audios) && audios.length > 0) {
                    const newSavedSongsDetails = audios.map(audio => {
                        const { primary_artist1 = '', primary_artist2 = '', primary_artist3 = '', featuring1 = '', featuring2 = '', featuring3 = '',
                            author1 = '', author2 = '', author3 = '', composer1 = '', composer2 = '', composer3 = '' } = audio || {}
                        let primary = []
                        if (primary_artist1) {
                            primary.push(Number(primary_artist1))
                        }
                        if (primary_artist2) {
                            primary.push(Number(primary_artist2))
                        }
                        if (primary_artist3) {
                            primary.push(Number(primary_artist3))
                        }

                        primary = primary.map(artist => primaryArtist.find(item => item.artist_id === artist))

                        let featuring = []
                        if (featuring1) {
                            featuring.push(Number(featuring1))
                        }
                        if (featuring2) {
                            featuring.push(Number(featuring2))
                        }
                        if (featuring3) {
                            featuring.push(Number(featuring3))
                        }

                        featuring = featuring.map(artist => featuringArtist.find(item => item.artist_id === artist))

                        let authorList = []
                        if (author1) {
                            // Split by separator |~| for new data, or use firstName only for old data
                            const parts = author1.split('|~|');
                            if (parts.length === 2) {
                                authorList.push({ firstName: parts[0], lastName: parts[1] })
                            } else {
                                // Backward compatibility: if no separator, put entire name in firstName
                                authorList.push({ firstName: author1, lastName: "" })
                            }
                        }
                        if (author2) {
                            const parts = author2.split('|~|');
                            if (parts.length === 2) {
                                authorList.push({ firstName: parts[0], lastName: parts[1] })
                            } else {
                                authorList.push({ firstName: author2, lastName: "" })
                            }
                        }
                        if (author3) {
                            const parts = author3.split('|~|');
                            if (parts.length === 2) {
                                authorList.push({ firstName: parts[0], lastName: parts[1] })
                            } else {
                                authorList.push({ firstName: author3, lastName: "" })
                            }
                        }

                        let composerList = []
                        if (composer1) {
                            // Split by separator |~| for new data, or use firstName only for old data
                            const parts = composer1.split('|~|');
                            if (parts.length === 2) {
                                composerList.push({ firstName: parts[0], lastName: parts[1] })
                            } else {
                                // Backward compatibility: if no separator, put entire name in firstName
                                composerList.push({ firstName: composer1, lastName: "" })
                            }
                        }
                        if (composer2) {
                            const parts = composer2.split('|~|');
                            if (parts.length === 2) {
                                composerList.push({ firstName: parts[0], lastName: parts[1] })
                            } else {
                                composerList.push({ firstName: composer2, lastName: "" })
                            }
                        }
                        if (composer3) {
                            const parts = composer3.split('|~|');
                            if (parts.length === 2) {
                                composerList.push({ firstName: parts[0], lastName: parts[1] })
                            } else {
                                composerList.push({ firstName: composer3, lastName: "" })
                            }
                        }

                        return {
                            ...audio,
                            saved: true,
                            edit: true,
                            selectedSongPrimaryArtist: primary,
                            selectedSongfeaturingArtist: featuring,
                            selectedSongAuthor: authorList,
                            selectedSongComposer: composerList

                        }

                    })
                    setSavedSongsDetails(newSavedSongsDetails)
                }
                setRecipeFilePreview(`${API_URL}/${album_artwork}`)
            }).catch(err => {
                props.setLoader(false)
            })
        }
    }, [insertDraft])

    const onFetchLogos = () => {
        actions.getLogos().then(res => {
            setPlatformLogo(res.body)
        })
    }

    const onFetchArtists = async () => {
        await actions.getArtist('primary').then(res => setPrimaryArtist(res.body.map(item => ({ ...item, label: item.artist_name, value: item.artist_id }))))
        await actions.getArtist('featuring').then(res => setFeaturingArtist(res.body.map(item => ({ ...item, label: item.artist_name, value: item.artist_id }))))
        if (params.id) setInsertDraft(true)
    }

    const handleTabChange = (e, value) => {
        setTabIndex(value)
    }

    const onChangeArtist = ({ target: { name = '', value = '' } }) => {
        setAddArtist({ ...addArtist, [name]: value })
    }

    const onChangeHandler = ({ target: { name = '', value = '' } }) => {

    }

    const onSongFileHandler = (e, index) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 104857600) {
            return toastError('Audio file more than 100 MB is not allowed.')
        }
        if (!isValidExtension(file)) {
            return toastError('Supported Audio files (.mp3 & .wav)')
        }

        // Store the file without uploading
        setSelectedAudioFile(file)
        setSongInfoMusicLink(null) // Clear any previously uploaded file
        setShowUpload(true)
        setIsProgressDone(true)
        toastSuccess(`File "${file.name}" selected. Click "Upload and Submit" to upload.`)
    }

    const isValidExtension = (file) => {
        let lastDot = file.name.lastIndexOf(".")
        let ext = file.name.substring(lastDot + 1)
        if (ext === 'mp3' ||
            ext === 'wav'
        ) {
            return true
        }
        return false
    }

    const onFileHandler = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 1572864) {
                return toastError('File more than 1.5 MB is not allowed.')
            }
            props.setLoader(true)
            commonActions.upload(file).then(res => {
                props.setLoader(false)
                setReleaseInfo({ ...releaseInfo, album_artwork: res.body.filename })
                previewsFile(file)
                toastSuccess("Artwork uploaded successfully.")
            }).catch(err => {
                props.setLoader(false)
                toastError(err.message || 'Something went wrong')
            })
        }
    }

    const previewsFile = (file) => {
        const reader = new FileReader();
        reader.addEventListener("load", function () {
            //convert
            setRecipeFilePreview(reader.result)
        }, false);
        if (file) {
            reader.readAsDataURL(file);
        }
    }

    const onSubmitAddArtist = () => {
        props.setLoader(true)
        actions.addArtist(addArtist).then(res => {
            props.setLoader(false)
            setAddArtist({ ...initialArtist })
            toastSuccess(res.message)
            setOpenAddPrimary(false)
            setOpenAddFeaturing(false)
            onFetchArtists();
        }).finally(() => props.setLoader(false))
    }

    const removeSelectedPrimary = (type, index) => {
        if (type === "primary") {
            let newArr = [...selectedPrimaryArtist]
            newArr.splice(index, 1)
            setSelectedPrimaryArtist(newArr)
        } else {
            let newArr = [...selectedFeaturingArtist]
            newArr.splice(index, 1)
            setSelectedFeaturingArtist(newArr)
        }
    }

    const onChangeSelect = (e, type) => {
        if (type === "primary") {
            const isExists = selectedPrimaryArtist.find(item => item.artist_id === e.artist_id)
            if (isExists) {
                return toastError("This artist is already added.")
            }
            if (selectedFeaturingArtist.length === 1 && selectedPrimaryArtist.length > 1) {
                return toastError("Maximum artist limit reached")
            }
            if (selectedFeaturingArtist.length === 2 && selectedPrimaryArtist.length > 0) {
                return toastError("Maximum artist limit reached")
            }
            if (selectedPrimaryArtist.length > 2) {
                return toastError("Maximum artist limit reached")
            }
            setSelectedPrimaryArtist([...selectedPrimaryArtist, e])
        } else {
            const isExists = selectedFeaturingArtist.find(item => item.artist_id === e.artist_id)
            if (isExists) {
                return toastError("This artist is already added.")
            }
            if (selectedPrimaryArtist.length === 1 && selectedFeaturingArtist.length > 1) {
                return toastError("Maximum artist limit reached")
            }
            if (selectedPrimaryArtist.length === 2 && selectedFeaturingArtist.length > 0) {
                return toastError("Maximum artist limit reached")
            }
            if (selectedPrimaryArtist.length === 3) {
                return toastError("Maximum artist limit reached")
            }
            if (selectedFeaturingArtist.length > 1) {
                return toastError("Maximum artist limit reached")
            }
            setSelectedFeaturingArtist([...selectedFeaturingArtist, e])
        }
    }

    const createReleaseInfo = () => {
        // Validate release date
        const minDate = moment().add(6, 'd').startOf('day').valueOf()
        if (!releaseInfo.release_date) {
            setReleaseDateError('Release date is required.')
            return toastError('Please select a release date.')
        }
        if (releaseInfo.release_date < minDate) {
            setReleaseDateError('The selected date is invalid. Please select a date at least 6 days from today.')
            return toastError('Release date must be at least 6 days from today.')
        }

        let newReleaseInfo = { ...releaseInfo }
        selectedPrimaryArtist.forEach((item, key) => {
            newReleaseInfo = { ...newReleaseInfo, [`primary_artist${key + 1}`]: item.artist_id }
        })
        selectedFeaturingArtist.forEach((item, key) => {
            newReleaseInfo = { ...newReleaseInfo, [`featuring${key + 1}`]: item.artist_id }
        })
        props.setLoader(true)
        if (editMode) {
            actions.updateReleaseInfo(newReleaseInfo).then(res => {
                props.setLoader(false)
                toastSuccess(res.message)
                handleTabChange({}, 2)
                setConfirmOpen(false)
            }).catch(err => {
                toastError(err.message)
                props.setLoader(false)
            })
            return
        }
        actions.createReleaseInfo(newReleaseInfo).then(res => {
            toastSuccess(res.message)
            setReleaseID(res.release_id)
            setPlatform({ ...platform, release_id: res.release_id })
            saveObject('releaseId', res.release_id)
            saveObject('releaseInfo', releaseInfo)
            setStepsDone({ ...stepsDone, first: true })
            setDisableTab({ ...disableTab, second: false })
            handleTabChange({}, 2)
            setEditMode(true)
            setConfirmOpen(false)
            setTimeout(() => {
                props.setLoader(false)
            }, 1000)
        }).catch(err => {
            toastError(err.message)
            props.setLoader(false)
        })
    }

    const onSaveSongDetails = () => {
        // Check if file is selected but not uploaded yet
        if (!selectedAudioFile && !songInfoMusicLink) {
            return toastError('Please select an audio file.')
        }

        // If file is selected but not uploaded, upload it first
        if (selectedAudioFile && !songInfoMusicLink) {
            const data1 = new FormData();
            data1.append("file", selectedAudioFile)
            props.setLoader(true)
            setUploadProgress(0)
            setIsProgressDone(false)

            axios.post(`${API_URL}/api/upload`, data1, {
                headers: {
                    ...getHeaders()
                },
                onUploadProgress: (progressEvent) => {
                    const uploadProgress = Math.round(progressEvent.loaded / progressEvent.total * 100);
                    setUploadProgress(uploadProgress)
                }
            }).then(res => {
                setSongInfoMusicLink(res.data.body.filename)
                setIsProgressDone(true)
                // Now save the song details with the uploaded file
                saveSongDetailsWithFile(res.data.body.filename)
            }).catch(err => {
                props.setLoader(false)
                setIsProgressDone(true)
                toastError(err.message)
            })
            return
        }

        // File already uploaded, proceed to save
        saveSongDetailsWithFile(songInfoMusicLink)
    }

    const saveSongDetailsWithFile = (audioFileName) => {
        let newSongInfo = { ...songInfo }
        let newSavedSongsDetails = [...savedSongsDetails]
        selectedSongPrimaryArtist.forEach((item, key) => {
            newSongInfo = { ...newSongInfo, [`primary_artist${key + 1}`]: item.artist_id }
        })
        selectedSongfeaturingArtist.forEach((item, key) => {
            newSongInfo = { ...newSongInfo, [`featuring${key + 1}`]: item.artist_id }
        })
        selectedSongAuthor.forEach((item, key) => {
            // Combine firstName and lastName with separator |~|
            const combinedName = `${item.firstName}|~|${item.lastName}`;
            newSongInfo = { ...newSongInfo, [`author${key + 1}`]: combinedName }
        })
        selectedSongComposer.forEach((item, key) => {
            // Combine firstName and lastName with separator |~|
            const combinedName = `${item.firstName}|~|${item.lastName}`;
            newSongInfo = { ...newSongInfo, [`composer${key + 1}`]: combinedName }
        })
        newSongInfo.selectedSongPrimaryArtist = selectedSongPrimaryArtist
        newSongInfo.selectedSongfeaturingArtist = selectedSongfeaturingArtist
        newSongInfo.selectedSongAuthor = selectedSongAuthor
        newSongInfo.selectedSongComposer = selectedSongComposer
        newSongInfo.audio_track = audioFileName
        if (!props.loader) props.setLoader(true)
        if (newSongInfo.edit) {
            actions.updateSongInfo({ ...newSongInfo, release_id: releaseID }).then(res => {
                props.setLoader(false)
                toastSuccess(res.message)
                setOpenSongDetail(false)
                setSongInfoMusicLink(null)
                setSelectedAudioFile(null)
                setSelectedSongPrimaryArtist([])
                setSelectedSongfeaturingArtist([])
                setSelectedSongAuthor([{ firstName: "", lastName: "" }])
                setSelectedSongComposer([{ firstName: "", lastName: "" }])
                newSavedSongsDetails[currentEditIndex] = { ...newSongInfo, saved: true, edit: true }
                setSavedSongsDetails(newSavedSongsDetails)
            }).catch(err => {
                props.setLoader(false)
                toastError(err.message)
            })
            return
        }

        actions.addSongInfo({ ...newSongInfo, release_id: releaseID }).then(res => {
            props.setLoader(false)
            newSavedSongsDetails[currentEditIndex] = { ...newSongInfo, saved: true, edit: true, audio_id: res.audio_id }
            setOpenSongDetail(false)
            setSongInfoMusicLink(null)
            setSelectedAudioFile(null)
            setSelectedSongPrimaryArtist([])
            setSelectedSongfeaturingArtist([])
            setSelectedSongAuthor([{ firstName: "", lastName: "" }])
            setSelectedSongComposer([{ firstName: "", lastName: "" }])
            setStepsDone({ ...stepsDone, second: true })
            setDisableTab({ ...disableTab, third: false })
            setSavedSongsDetails(newSavedSongsDetails)
        }).catch(err => {
            props.setLoader(false)
            toastError(err.message)
        })
    }

    const addNewTrack = () => {
        const isSaved = savedSongsDetails.find(item => !item.saved) || null;
        if (!isSaved) {
            setShowUpload(false)
            setIsProgressDone(false)
            setUploadProgress(0)
            setShowSubmitSong(false)
            setSongInfoMusicLink(null)
            setSelectedAudioFile(null)
            setSavedSongsDetails([...savedSongsDetails, { ...initialSongInfo }])
            setSongInfo({ ...initialSongInfo })
        } else {
            toastError('Please save the song details first.')
        }
    }

    const onClickSongEdit = (index) => {
        const isSaved = savedSongsDetails.find(item => !item.saved) || null;
        if (!isSaved) {
            let newSavedSongsDetails = [...savedSongsDetails]
            setShowUpload(true)
            setIsProgressDone(true)
            setUploadProgress(100)
            setCurrentEditIndex(index)
            setSelectedAudioFile(null)
            newSavedSongsDetails[index].saved = false
            setSavedSongsDetails(newSavedSongsDetails)
            setSongInfo(newSavedSongsDetails[index])
            setSongInfoMusicLink(newSavedSongsDetails[index].audio_track)
            setSelectedSongPrimaryArtist(newSavedSongsDetails[index].selectedSongPrimaryArtist)
            setSelectedSongfeaturingArtist(newSavedSongsDetails[index].selectedSongfeaturingArtist)
            setSelectedSongAuthor(newSavedSongsDetails[index].selectedSongAuthor)
            setSelectedSongComposer(newSavedSongsDetails[index].selectedSongComposer)
        } else {
            toastError('Please save the song details first.')
        }
    }

    const deleteSavedSongDetails = (index) => {
        let newSavedSongsDetails = [...savedSongsDetails]
        newSavedSongsDetails.splice(index, 1)
        setSavedSongsDetails(newSavedSongsDetails)
    }

    const validOnSaveSongDetails = () => {
        const { title, p_line, producer,
            production_year, genre, subgenre, price_tier, track_title_language, lyrics_language, destribute_music,
            download_video_link, caller_tune } = songInfo

        // Validate that all lyricists have both firstName and lastName filled
        const isAuthorValid = selectedSongAuthor.every(author => author.firstName && author.firstName.trim() !== '' && author.lastName && author.lastName.trim() !== '');
        if (!isAuthorValid) {
            return toastError('Please fill both First Name and Last Name for all Lyricists')
        }

        // Validate that all composers have both firstName and lastName filled
        const isComposerValid = selectedSongComposer.every(composer => composer.firstName && composer.firstName.trim() !== '' && composer.lastName && composer.lastName.trim() !== '');
        if (!isComposerValid) {
            return toastError('Please fill both First Name and Last Name for all Composers')
        }

        if (!title || selectedSongPrimaryArtist.length === 0 || selectedSongAuthor.length === 0 || selectedSongComposer.length === 0
            || !p_line || !producer || !production_year || !genre || !subgenre || !price_tier || !track_title_language || !lyrics_language || !caller_tune
        ) {
            return toastError('Please fill all required fields')
        }

        // Validate caller tune timing - should not be 0 or 00:00:00
        const callerTuneValue = caller_tune.replace(/:/g, '');
        if (callerTuneValue === '0' || callerTuneValue === '00' || callerTuneValue === '000000' || parseInt(callerTuneValue) === 0) {
            return toastError('Caller Tune Timing cannot be 0 or 00:00:00. Please enter a valid time.')
        }

        if (destribute_music === 'Yes' && !download_video_link) {
            return toastError('Link to music video is required.')
        }
        setOpenSongDetail(false)
        setShowSubmitSong(true)
    }

    return (
        <>
        <SEO
            title={params.id ? "Edit Audio Release" : "Create Audio Release"}
            description="Create or edit your audio releases and distribute your music to all major streaming platforms worldwide."
        />
        {initialLoader ? <Grid container style={{ height: "100vh" }}></Grid> : awayData.status ? <PageContainer>
            <Container maxWidth="lg" sx={{ display: 'flex', alignItems: 'center', minHeight: 'calc(100vh - 128px)' }}>
                <Box sx={{ width: '100%' }}>
                    <AwayStatusModal awayText={awayData.text} />
                </Box>
            </Container>
        </PageContainer> : isUserRevoked ? <PageContainer>
            <Grid container style={{ height: "calc(90vh - 64px)" }}>
                <Grid item xs={12} sm={10} md={7} lg={5} style={{ margin: "auto" }}>
                    <div className="revoked-user-container">
                        <div style={{ width: "100%", display: "flex" }}>
                            <img height="200px" src={noaccess} alt="" style={{ margin: "auto" }} />
                        </div>
                        <p style={{ fontSize: 20, fontWeight: 500, textAlign: "center" }}>You cannot create a release due to the violation of Fronic Media distribution terms. To get back the access, please contact support@fronicmedia.com.</p>
                        <p style={{ float: "right", marginTop: 15 }}>-Team Fronic media.</p>
                    </div>
                </Grid>
            </Grid>
        </PageContainer> : <PageContainer>
            <PageHeader>
                <h1>
                    <AlbumIcon
                        sx={{
                            fontSize: '2.5rem',
                            background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
                            borderRadius: '12px',
                            padding: '8px',
                            color: '#ffffff'
                        }}
                    />
                    Create New Release
                </h1>
            </PageHeader>
            <StyledPaper>
                <StepperContainer>
                    <StyledStepper
                        activeStep={tabIndex - 1}
                        alternativeLabel
                        connector={<StyledStepConnector />}
                    >
                        <Step completed={stepsDone.first}>
                            <StyledStepLabel
                                onClick={() => !disableTab.first && handleTabChange({}, 1)}
                                StepIconComponent={() => (
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '56px',
                                        height: '56px',
                                        borderRadius: '50%',
                                        background: stepsDone.first
                                            ? 'linear-gradient(135deg, #00bfa5 0%, #00897b 100%)'
                                            : tabIndex === 1
                                            ? 'linear-gradient(135deg, #1a73e8 0%, #1557b0 100%)'
                                            : 'rgba(0, 0, 0, 0.12)',
                                        boxShadow: (stepsDone.first || tabIndex === 1) ? '0 4px 12px rgba(26, 115, 232, 0.3)' : 'none',
                                        transition: 'all 0.3s ease',
                                    }}>
                                        {stepsDone.first ? (
                                            <CheckCircleIcon sx={{ fontSize: '2rem', color: '#ffffff' }} />
                                        ) : (
                                            <InfoIcon sx={{ fontSize: '2rem', color: '#ffffff' }} />
                                        )}
                                    </Box>
                                )}
                            >
                                Release Info
                            </StyledStepLabel>
                        </Step>
                        <Step completed={stepsDone.second}>
                            <StyledStepLabel
                                onClick={() => !disableTab.second && handleTabChange({}, 2)}
                                StepIconComponent={() => (
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '56px',
                                        height: '56px',
                                        borderRadius: '50%',
                                        background: stepsDone.second
                                            ? 'linear-gradient(135deg, #00bfa5 0%, #00897b 100%)'
                                            : tabIndex === 2
                                            ? 'linear-gradient(135deg, #1a73e8 0%, #1557b0 100%)'
                                            : 'rgba(0, 0, 0, 0.12)',
                                        boxShadow: (stepsDone.second || tabIndex === 2) ? '0 4px 12px rgba(26, 115, 232, 0.3)' : 'none',
                                        transition: 'all 0.3s ease',
                                    }}>
                                        {stepsDone.second ? (
                                            <CheckCircleIcon sx={{ fontSize: '2rem', color: '#ffffff' }} />
                                        ) : (
                                            <MusicNoteIcon sx={{ fontSize: '2rem', color: '#ffffff' }} />
                                        )}
                                    </Box>
                                )}
                            >
                                Song Info
                            </StyledStepLabel>
                        </Step>
                        <Step completed={stepsDone.third}>
                            <StyledStepLabel
                                onClick={() => !disableTab.third && handleTabChange({}, 3)}
                                StepIconComponent={() => (
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '56px',
                                        height: '56px',
                                        borderRadius: '50%',
                                        background: stepsDone.third
                                            ? 'linear-gradient(135deg, #00bfa5 0%, #00897b 100%)'
                                            : tabIndex === 3
                                            ? 'linear-gradient(135deg, #1a73e8 0%, #1557b0 100%)'
                                            : 'rgba(0, 0, 0, 0.12)',
                                        boxShadow: (stepsDone.third || tabIndex === 3) ? '0 4px 12px rgba(26, 115, 232, 0.3)' : 'none',
                                        transition: 'all 0.3s ease',
                                    }}>
                                        {stepsDone.third ? (
                                            <CheckCircleIcon sx={{ fontSize: '2rem', color: '#ffffff' }} />
                                        ) : (
                                            <CloudUploadIcon sx={{ fontSize: '2rem', color: '#ffffff' }} />
                                        )}
                                    </Box>
                                )}
                            >
                                Platforms
                            </StyledStepLabel>
                        </Step>
                        <Step completed={stepsDone.fourth}>
                            <StyledStepLabel
                                onClick={() => !disableTab.fourth && handleTabChange({}, 4)}
                                StepIconComponent={() => (
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '56px',
                                        height: '56px',
                                        borderRadius: '50%',
                                        background: stepsDone.fourth
                                            ? 'linear-gradient(135deg, #00bfa5 0%, #00897b 100%)'
                                            : tabIndex === 4
                                            ? 'linear-gradient(135deg, #1a73e8 0%, #1557b0 100%)'
                                            : 'rgba(0, 0, 0, 0.12)',
                                        boxShadow: (stepsDone.fourth || tabIndex === 4) ? '0 4px 12px rgba(26, 115, 232, 0.3)' : 'none',
                                        transition: 'all 0.3s ease',
                                    }}>
                                        {stepsDone.fourth ? (
                                            <CheckCircleIcon sx={{ fontSize: '2rem', color: '#ffffff' }} />
                                        ) : (
                                            <SendIcon sx={{ fontSize: '2rem', color: '#ffffff' }} />
                                        )}
                                    </Box>
                                )}
                            >
                                Submission
                            </StyledStepLabel>
                        </Step>
                    </StyledStepper>
                </StepperContainer>
                <Box>
                <TabPanel value={tabIndex} index={1}>
                    <ReleaseInfo
                        addArtist={addArtist}
                        editMode={editMode}
                        releaseInfo={releaseInfo}
                        setAddArtist={setAddArtist}
                        primaryArtist={primaryArtist}
                        onFileHandler={onFileHandler}
                        setReleaseInfo={setReleaseInfo}
                        onChangeSelect={onChangeSelect}
                        onChangeHandler={onChangeHandler}
                        featuringArtist={featuringArtist}
                        createReleaseInfo={() => setConfirmOpen(true)}
                        recipeFilePreview={recipeFilePreview}
                        setOpenAddPrimary={setOpenAddPrimary}
                        setOpenAddFeaturing={setOpenAddFeaturing}
                        selectedPrimaryArtist={selectedPrimaryArtist}
                        removeSelectedPrimary={removeSelectedPrimary}
                        selectedFeaturingArtist={selectedFeaturingArtist}
                        releaseDateError={releaseDateError}
                        setReleaseDateError={setReleaseDateError}
                    />
                </TabPanel>
                <TabPanel value={tabIndex} index={2}>
                    <SongInfo
                        isSingleTrack={releaseInfo.release_type === 'single'}
                        songInfo={songInfo}
                        showUpload={showUpload}
                        isProgressDone={isProgressDone}
                        addNewTrack={addNewTrack}
                        songInfoMusicLink={songInfoMusicLink}
                        selectedAudioFile={selectedAudioFile}
                        deleteSavedSongDetails={deleteSavedSongDetails}
                        onSaveSongDetails={onSaveSongDetails}
                        onClickSongEdit={onClickSongEdit}
                        uploadProgress={uploadProgress}
                        showSubmitSong={showSubmitSong}
                        setCurrentEditIndex={setCurrentEditIndex}
                        savedSongsDetails={savedSongsDetails}
                        setOpenSongDetail={setOpenSongDetail}
                        onSongFileHandler={onSongFileHandler}
                        recipeFilePreview={recipeFilePreview}
                        disableTab={disableTab}
                        handleTabChange={handleTabChange}
                    />
                </TabPanel>
                <TabPanel value={tabIndex} index={3}>
                    <Platform
                        editMode={editMode}
                        releaseID={releaseID}
                        platformLogo={platformLogo}
                        setStepsDone={setStepsDone}
                        platform={platform}
                        setPlatform={setPlatform}
                        stepsDone={stepsDone}
                        handleTabChange={handleTabChange}
                        setLoader={props.setLoader}
                        setDisableTab={setDisableTab}
                        disableTab={disableTab}
                    />
                </TabPanel>
                <TabPanel value={tabIndex} index={4}>
                    <Submission
                        setLoader={props.setLoader}
                        releaseID={releaseID}
                    />
                </TabPanel>
                </Box>
            </StyledPaper>
            <CustomAddModal
                open={openAddPrimary}
                maxWidth="xs"
                title={`Add Primary Artist`}
                onSubmitConfirm={onSubmitAddArtist}
                handleClose={() => { setAddArtist({ ...initialArtist }); setOpenAddPrimary(false) }}
            >
                <AddArtist
                    type="primary"
                    onChange={onChangeArtist}
                    addArtist={addArtist}
                />
            </CustomAddModal>

            <CustomAddModal
                maxWidth="xs"
                open={openAddFeaturing}
                title={`Add Featuring Artist`}
                onSubmitConfirm={onSubmitAddArtist}
                handleClose={() => { setAddArtist({ ...initialArtist }); setOpenAddFeaturing(false) }}
            >
                <AddArtist
                    type="featuring"
                    onChange={onChangeArtist}
                    addArtist={addArtist}
                />
            </CustomAddModal>

            <ConfirmModal
                message={`Are you ready to save your release information? You can come back anytime to continue your submission from the Drafts section.`}
                open={confirmOpen}
                title={`Save Release Information`}
                onSubmitConfirm={createReleaseInfo}
                handleClose={() => setConfirmOpen(false)}
            />

            <CustomAddModal
                open={openSongDetail}
                title={`Add Audio Details`}
                saveLabel="Upload and Submit"
                maxWidth="md"
                onSubmitConfirm={validOnSaveSongDetails}
                handleClose={() => setOpenSongDetail(false)}
            >
                <SongDetailForm
                    songInfo={songInfo}
                    releaseInfo={releaseInfo}
                    setSongInfo={setSongInfo}
                    addArtist={addArtist}

                    featuringArtist={featuringArtist}
                    setAddArtist={setAddArtist}
                    openAddPrimary={openAddPrimary}
                    setOpenAddPrimary={setOpenAddPrimary}
                    setOpenAddFeaturing={setOpenAddFeaturing}
                    primaryArtist={primaryArtist}
                    selectedSongPrimaryArtist={selectedSongPrimaryArtist}
                    setSelectedSongPrimaryArtist={setSelectedSongPrimaryArtist}
                    selectedSongfeaturingArtist={selectedSongfeaturingArtist}
                    setSelectedSongfeaturingArtist={setSelectedSongfeaturingArtist}
                    selectedSongAuthor={selectedSongAuthor}
                    setSelectedSongAuthor={setSelectedSongAuthor}
                    selectedSongComposer={selectedSongComposer}
                    setSelectedSongComposer={setSelectedSongComposer}
                />
            </CustomAddModal>

        </PageContainer>}
        </>
    )
}